export default __webpack_public_path__ + "static/media/anota-ai.1176fcde.png";